import { isNil } from 'ramda';
import { PersonAccounts } from '../../type';

export const shouldShowTResp = (data: PersonAccounts) => {
  const mcLrpType = data['T_LRP.MC_LRP_TYPE'];
  const tCatShorcut = data['T_CAT.SHORTCUT'];
  return !isNil(mcLrpType) && tCatShorcut !== 'GOLD';
};
